<!-- Start Feedback Area -->
<section class="feedback-area">
    <div class="container">
        <div class="section-title">
            <h2>
                What Our Customers Say About
                <strong>SolarCiti</strong>
            </h2>

            <p>
                Discover why customers choose <strong>SolarCiti</strong>
                for reliable solar solutions, professional installation,
                and dedicated support.
            </p>
        </div>

        <div class="row">
            <div class="feedback-slides owl-carousel owl-theme">

                <div
                    class="single-feedback-item"
                    *ngFor="let feedback of feedbackData"
                >
                    <div class="feedback-desc">
                        <p>
                            {{ feedback.feedback }}
                        </p>
                    </div>

                    <div class="client-info">
                        <img
                            [src]="feedback.image"
                            [alt]="feedback.name + ' - SolarCiti Customer'"
                        />

                        <h3>{{ feedback.name }}</h3>

                        <span>
                            {{ feedback.system }}
                            | {{ feedback.category }}
                            | {{ feedback.location }}
                        </span>

                        <!-- <div class="rating">
                            <i
                                *ngFor="let star of [].constructor(feedback.rating)"
                                class="bx bxs-star"
                            ></i>
                        </div> -->
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="feedback-shape">
        <img src="assets/img/white-shape2.png" alt="image">
    </div>

    <div class="shape-rectangle">
        <img src="assets/img/shape/1.png" alt="image">
    </div>
</section>
<!-- End Feedback Area -->